import React, { useState, useEffect } from 'react';
import '../instituteLobo/../header/style.css';
import { Header } from "../instituteLobo";
import { AdminNavbar } from "../instituteLobo";
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url } from '../../../constants/apiConstants';

function InstituteLoboList() {
    const navigate = useNavigate();
    const [roleList, setRoleList] = useState([]);

    useEffect(() => {
        fetchRoles();
    }, []);

    const fetchRoles = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/getCollegeLogoMediaFile`, {
                headers: {
                    "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                    "Content-Type": "application/json",
                },
            });
            setRoleList(response.data);
        } catch (err) {
            console.error("Error fetching roles:", err);
        }
    };

    const handleDelete = async (id) => {
        try {
            const response = await axios.delete(`${API_BASE_URL}/deleteCollegeLogoMediaFileById/${id}`, {
                headers: {
                    "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                    "Content-Type": "application/json",
                },
            });

            if (response.status === 200) {
                setRoleList(roleList.filter((item) => item.id !== id));
            }
        } catch (error) {
            console.error("Error deleting role:", error);
        }
    };

    return (
        <div>
            <Header />
            <div className="main-container">
                <AdminNavbar />
                <div className="main">
                    <div className="report-container">
                        <div className="report-header">
                            <h1 className="recent-Articles">Institute Lobo</h1>
                            <Link className="recent-Articles" to={`/admin/instituteLoboCreate`}>
                                Create New Institute Lobo
                            </Link>
                        </div>

                        <div className="report-body">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Institute Name</th>
                                        <th>Institute Lobo</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {roleList.length > 0 ? (
                                        roleList.map((item, index) => (
                                            <tr key={item.id}>
                                                <td>{index + 1}</td>
                                                <td>{item.name}</td>
                                                <td>
                                                    {item.media_image_path ? (
                                                        <img
                                                            src={`${Image_Base_Url}${item.media_image_path}`}
                                                            alt="Institute Lobo"
                                                            style={{ width: "50px", height: "50px" }}
                                                        />
                                                    ) : (
                                                        "No Image"
                                                    )}
                                                </td>
                                                <td>
                                                    <Link to={`/admin/editinstituteLobo/${item.id}`}>
                                                        <i className="fa fa-pencil" aria-hidden="true"></i>
                                                    </Link>
                                                    <i
                                                        className="fa fa-trash-o"
                                                        aria-hidden="true"
                                                        onClick={() => handleDelete(item.id)}
                                                    ></i>
                                                </td>
                                                <td>
                                                    <span
                                                        style={{ fontSize: "16px", color: "red", cursor: "pointer", marginLeft: "10px" }}
                                                        onClick={() => handleDelete(item.id)}
                                                    >
                                                        Delete
                                                    </span>
                                                </td>

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                No records found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InstituteLoboList;
